module.exports = __webpack_public_path__ + "static/img/item-4.783fd4a8.png";